import { render, staticRenderFns } from "./VendorManagementReports.vue?vue&type=template&id=1f8a746c&"
import script from "./VendorManagementReports.vue?vue&type=script&lang=js&"
export * from "./VendorManagementReports.vue?vue&type=script&lang=js&"
import style0 from "./VendorManagementReports.vue?vue&type=style&index=0&id=1f8a746c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports